import React from 'react';
import Icon from '../../../components/AppIcon';

const PortfolioStats = () => {
  const stats = [
    {
      category: "Investment Performance",
      metrics: [
        { label: "Total Portfolio Value", value: "€127M", change: "+23.4%", icon: "TrendingUp" },
        { label: "Average Return", value: "3.2x", change: "+0.4x YoY", icon: "Target" },
        { label: "Success Rate", value: "89%", change: "Industry leading", icon: "Award" }
      ]
    },
    {
      category: "Portfolio Composition",
      metrics: [
        { label: "Active Companies", value: "47", change: "+8 this year", icon: "Building2" },
        { label: "Successful Exits", value: "12", change: "€45M realized", icon: "CheckCircle" },
        { label: "Unicorn Track", value: "5", change: "€1B+ potential", icon: "Star" }
      ]
    },
    {
      category: "Geographic Distribution",
      metrics: [
        { label: "Germany", value: "62%", change: "Primary market", icon: "MapPin" },
        { label: "EU Markets", value: "28%", change: "Expanding", icon: "Globe" },
        { label: "Global", value: "10%", change: "Strategic", icon: "Plane" }
      ]
    },
    {
      category: "Sector Focus",
      metrics: [
        { label: "E-commerce", value: "35%", change: "Leading sector", icon: "ShoppingCart" },
        { label: "SaaS", value: "30%", change: "High growth", icon: "Cloud" },
        { label: "FinTech", value: "20%", change: "Emerging", icon: "CreditCard" }
      ]
    }
  ];

  return (
    <section className="bg-muted/30 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-foreground mb-4">Portfolio Performance</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Comprehensive overview of our investment portfolio performance, 
            geographic distribution, and sector focus areas.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {stats?.map((category, categoryIndex) => (
            <div key={categoryIndex} className="bg-background border border-border rounded-brand p-6 shadow-brand-sm">
              <h3 className="text-xl font-semibold text-foreground mb-6 flex items-center space-x-2">
                <div className="w-2 h-2 bg-primary rounded-full"></div>
                <span>{category?.category}</span>
              </h3>

              <div className="space-y-4">
                {category?.metrics?.map((metric, metricIndex) => (
                  <div key={metricIndex} className="flex items-center justify-between p-4 bg-muted/20 rounded-brand-sm hover:bg-muted/30 transition-brand">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-primary/10 rounded-brand-sm flex items-center justify-center">
                        <Icon name={metric?.icon} size={20} className="text-primary" />
                      </div>
                      
                      <div>
                        <div className="font-medium text-foreground">{metric?.label}</div>
                        <div className="text-sm text-muted-foreground">{metric?.change}</div>
                      </div>
                    </div>

                    <div className="text-right">
                      <div className="text-2xl font-bold text-foreground">{metric?.value}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Additional Insights */}
        <div className="mt-12 bg-gradient-to-r from-primary/5 to-accent/5 border border-primary/20 rounded-brand p-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="TrendingUp" size={32} className="text-primary" />
              </div>
              <h4 className="text-lg font-semibold text-foreground mb-2">Growth Trajectory</h4>
              <p className="text-sm text-muted-foreground">
                Portfolio companies show consistent 40%+ annual growth rates with strong market positioning.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Users" size={32} className="text-primary" />
              </div>
              <h4 className="text-lg font-semibold text-foreground mb-2">Founder Success</h4>
              <p className="text-sm text-muted-foreground">
                95% founder retention rate with ongoing strategic support and operational guidance.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Globe" size={32} className="text-primary" />
              </div>
              <h4 className="text-lg font-semibold text-foreground mb-2">Market Impact</h4>
              <p className="text-sm text-muted-foreground">
                Portfolio companies collectively serve 50M+ users across European and global markets.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PortfolioStats;